import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const MasterPayrollRBAC = {
  pageID: 'b248f5d4691fc2e1df17708c2b0e1f0e',
  elementID: {
    ViewMasterPayroll: 'ff2d0c009af39931d4a5077a9dfd7f72',
    AdjustFilter: 'a86fe982bafbfeaa6599e5b754cfd131',
    PreviewPayroll: 'f5e1295a2555677a86035f4035856479',
    EksporPayroll: '27cb1fa2ff07cef7d23ce9e56822c51b',
    PayrollDetail: 'd2bf444572ad3d574bcd57a87bd1dcfa',
    PreviewPayslipInPayrollDetail: '591c96554838b19ab0a534441fede555',
    BulkUploadVariablesByPeople: 'bfe97b89f8d9641b000406a6b4a670b6',
    BulkUploadVariablesByOps: '11fc9f889150d4c28a8b418441ece8e5',
    ValidatePayroll: 'c093d453e9b498d313421586d857c06f',
    PublishPayroll: '93ca664422afbfc489489c0f9bb877e2',
  },
} as const

export const useRBACMasterPayrollPage = createUseRBAC(MasterPayrollRBAC.elementID)
export type UseRBACMasterPayrollPageType = ReturnType<typeof useRBACMasterPayrollPage>

export const MasterPayrollBulkUploadRBAC = {
  pageID: '1feed7f99ab0f061bade26111e1c71e1',
  elementID: {
    ViewMasterPayrollBulkUpload: '51538f6a6d1cfa90aed7c8b6c91a9614',
  },
} as const
export const useRBACMasterPayrollBulkUploadPage = createUseRBAC(
  MasterPayrollBulkUploadRBAC.elementID,
)
export type UseRBACMasterPayrollBulkUploadPageType = ReturnType<
  typeof useRBACMasterPayrollBulkUploadPage
>

export const MasterPayslipRBAC = {
  pageID: 'b248f26ef51fc2e1df17708c29e5f87d',
  elementID: {
    ViewPayslip: '6730349c99df7f65e45e939129d84ce6',
    EditPayslip: '9a1a423c9b67e05d9e9e5f2cd377c18f',
    SettingPayslip: 'a026f2ad4c8f33e21055e59c0ce3e4b5',
  },
} as const

export const useRBACMasterPayslipPage = createUseRBAC(MasterPayslipRBAC.elementID)
export type UseRBACMasterPayslipPageType = ReturnType<typeof useRBACMasterPayslipPage>

export const MasterRateRBAC = {
  pageID: 'd9196dd54c8bd237598c192284c2bcad',
  elementID: {
    ViewRateList: 'ee9e24e395efe4214df460c36e4ec218',
    BulkUploadMasterRate: 'c0d2798c0e09b7b629bd31c6b3bd0b86',
    EditMasterRate: 'a6fcc7930e9b86e01e27afd80cc3ac07',
  },
} as const

export const useRBACMasterRatePage = createUseRBAC(MasterRateRBAC.elementID)
export type UseRBACMasterRatePageType = ReturnType<typeof useRBACMasterRatePage>

export const MasterRateBulkUploadRBAC = {
  pageID: 'd92aa2f407c6a2d02cb4ae14cbc992ce',
  elementID: {
    ViewMasterRateBulkUpload: '4e4c8046a9e47cc580878e253a03367c',
  },
} as const
export const useRBACMasterRateBulkUploadPage = createUseRBAC(MasterRateBulkUploadRBAC.elementID)
export type UseRBACMasterRateBulkUploadPageType = ReturnType<typeof useRBACMasterRateBulkUploadPage>
